export default "__VITE_ASSET__25843532__"